import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"

import {
  CardMembershipOutlined,
  ContentPasteOutlined,
  ExitToAppOutlined,
  ExpandMore,
  HeadsetMicOutlined,
  HomeRepairServiceOutlined,
  LockOutlined,
  Menu,
  PeopleOutlineOutlined,
  PersonOutlineOutlined,
  RecordVoiceOverOutlined,
  SettingsOutlined,
  StarBorderOutlined,
  WindowOutlined,
} from "@mui/icons-material"
import {
  Avatar,
  IconButton,
  MenuItem as MenuItemMUI,
  Menu as MenuMUI,
} from "@mui/material"
import { AiOutlinePieChart } from "react-icons/ai"

import { getPaths } from "app/homepage/routes"
import { useStore } from "hooks"
import { observer } from "mobx-react-lite"
import { useDispatch, useSelector } from "react-redux"
import { BasicMenu } from "shared/ui/menu"
import { setMobileMenuOpen } from "../../app/homepage/menuSlice"
import { setStep } from "../../app/homepage/stepSlice"
import { ChangePass } from "../../features/headerMenu/ChangePass"
import { ChangePhone } from "../../features/headerMenu/ChangePhone"
import { useGetSubscriptionStatusQuery } from "../../pages/subscription/subscriptionApi"
import { useGetBalanceQuery } from "../../pages/transaction/transactionApi"
import "./style.css"

const currentPaths = [
  {
    path: "/bookings",
    value: "Записи",
    Icon: ContentPasteOutlined,
    permission: null,
  },

  {
    path: "/customers",
    value: "Клиенты",
    Icon: RecordVoiceOverOutlined,
    permission: null,
  },
  {
    path: "/masters",
    value: "Сотрудники",
    Icon: PeopleOutlineOutlined,
    permission: null,
    counter: 2,
  },
  {
    path: "/categories",
    value: "Категории услуг",
    Icon: WindowOutlined,
    permission: null,
  },
  {
    path: "/services",
    value: "Услуги",
    Icon: HomeRepairServiceOutlined,
    permission: null,
  },
  // {
  //   path: "/analytics",
  //   value: "Аналитика",
  //   Icon: AiOutlinePieChart,
  //   permission: null,
  // },
  {
    path: "/finance/operations",
    value: "Финансовые операции",
    Icon: ContentPasteOutlined,
    permission: null,
  },
  {
    path: "/finance/salary",
    value: "Расчет зарплаты",
    Icon: PeopleOutlineOutlined,
    permission: null,
  },
  {
    path: "/directories/counterparties",
    value: "Контрагенты",
    Icon: PersonOutlineOutlined,
    permission: null,
  },
  {
    path: "/directories/items",
    value: "Статья движения",
    Icon: HomeRepairServiceOutlined,
    permission: null,
  },
  {
    path: "/directories/accounts",
    value: "Счета и кассы",
    Icon: WindowOutlined,
    permission: null,
  },
  {
    path: "/bookings-calendar",
    value: "Расписание",
    Icon: WindowOutlined,
    permission: null,
  },
  {
    path: "/reviews",
    value: "Отзывы",
    Icon: StarBorderOutlined,
    permission: null,
  },
  {
    path: "/feedback",
    value: "Обратная связь",
    Icon: HeadsetMicOutlined,
    permission: null,
  },
  {
    path: "/settings",
    value: "Настройки",
    Icon: SettingsOutlined,
    permission: null,
  },
  {
    path: "/subscription",
    value: "Подписка",
    Icon: CardMembershipOutlined,
    permission: null,
  },
]

export const HeaderMenu = observer(
  ({ toggleNavbar, isBannerVisible = false }) => {
    const { settings } = useSelector((state) => state.profileReducer)
    const { step } = useSelector((state) => state.StepSliceReducer)
    const { isMobileMenuOpen } = useSelector((state) => state.menuSliceReducer)
    const { user: mainUser } = useSelector((state) => state.main)
    const dispatch = useDispatch()
    const { auth } = useStore()
    const navigate = useNavigate()
    const isMobile = window.screen.width < 500
    const { data: balanceData, refetch: refetchBalance } = useGetBalanceQuery()
    const { data: subscriptionData } = useGetSubscriptionStatusQuery()

    // Функция для переключения меню с отслеживанием состояния
    const handleToggleNavbar = () => {
      dispatch(setMobileMenuOpen(!isMobileMenuOpen))
      toggleNavbar()
    }

    // const user = useSelector(state => state.main.user)

    const [toggle, setToggle] = useState(true)

    function toggleMenu() {
      setToggle(!toggle)
    }

    const count = 30

    const location = window.location.pathname
    const paths = getPaths(null)

    const [currentPath, setCurrentPath] = useState("")

    useEffect(() => {
      refetchBalance()
    }, [refetchBalance])

    useEffect(() => {
      // Force reflow to ensure styles are applied on mobile devices
      if (window.navigator.userAgent.includes("iPhone")) {
        const header = document.querySelector(".headerStickyWrap")
        if (header) {
          // Принудительный пересчет стилей
          header.style.transform = "translate3d(0,0,0)"
          header.style.webkitTransform = "translate3d(0,0,0)"
          // Trigger reflow
          void header.offsetHeight
        }
      }
    }, [])

    useEffect(() => {
      const currentPathInfo = currentPaths.filter(
        ({ path }) => path === location
      )
      const currentPathValue = currentPathInfo.length
        ? currentPathInfo[0].value
        : undefined
      setCurrentPath(currentPathValue)
      document.title = currentPathValue ?? "Navbat"
    }, [location])

    const [activePassword, setActivePassword] = useState(false)
    const [activeTel, setActiveTel] = useState(false)

    function onChooseOption(option) {
      switch (option) {
        case "Профиль":
          navigate("profile")
          break
        case "Сменить пароль":
          setActivePassword(true)
          break
        case "Сменить Номер телефона":
          setActiveTel(true)
          break
        case "Подписка":
          navigate("/subscription")
          break
        case "Выход":
          // dispatch(updatedIsAuth(false))
          localStorage.removeItem("accessToken")
          localStorage.removeItem("user")
          localStorage.removeItem("role_name")
          localStorage.removeItem("salon_id")
          // Also reset the Redux step state to initial value
          dispatch(setStep("0"))
          window.location.reload()
          // navigate("/login")
          break
        default:
          break
      }
      toggleMenu()
    }

    // Определяем статус подписки для бейджа
    const getSubscriptionBadge = () => {
      if (!subscriptionData) return "Free"

      // Если статус "none", считаем как free
      if (subscriptionData.status === "none") return "Free"

      const isPro = subscriptionData.plan?.toLowerCase() === "pro"

      // Если план не Pro, всегда возвращаем Free
      if (!isPro) return "Free"

      // Проверяем, активна ли подписка по API
      const isApiActive =
        subscriptionData.is_active || subscriptionData.status === "active"

      // Проверяем, не истекло ли время подписки
      const daysLeft = subscriptionData.days_left || 0
      const isTimeExpired = daysLeft <= 0

      // Подписка действительно активна только если:
      // 1. API говорит что активна И
      // 2. Время не истекло (days_left > 0)
      const isReallyActive = isApiActive && !isTimeExpired

      // Возвращаем Pro только если план Pro И подписка действительно активна
      // Если подписка истекла (days_left <= 0), возвращаем Free
      return isReallyActive ? "Pro" : "Free"
    }

    const options = [
      { title: "Профиль", link: "/profile", icon: PersonOutlineOutlined },
      { title: "Сменить пароль", link: "/changePass", icon: LockOutlined },
      // { title: "Сменить Номер телефона", link: "/changeTel" },
      {
        title: "Подписка",
        link: "/subscription",
        badge: getSubscriptionBadge(),
        icon: CardMembershipOutlined,
      },
      { separator: true },
      { title: "Выход", link: "/logout", icon: ExitToAppOutlined },
    ]

    const [anchorEl, setAnchorEl] = useState(null)
    const handleMenu = (event) => {
      setAnchorEl(event.currentTarget)
    }
    const handleClose = () => {
      setAnchorEl(null)
    }

    return (
      <>
        <div
          className='headerStickyWrap  sm:static w-full left-0 sm:top-10 z-50'
          style={{
            top: isBannerVisible ? "60px" : isMobile ? "0" : "10px",
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className='
          headerWrap w-full  max-h-[100px] 
          flex justify-between items-center h-full sm:h-fit py-2 px-4
          bg-blue sm:bg-white mb-0 sm:mb-5 sm:rounded-md
        '
          >
            {/* burger menu */}
            <div onClick={handleToggleNavbar} className='sm:hidden'>
              <Menu sx={{ color: "white" }} />
            </div>

            <p className='sm:block sm:text-base text-lg text-orange font-medium sm:text-blue'>
              {currentPath}
            </p>
            <div className='flex  '>
              <div className=' hidden sm:flex gap-4  bg-white items-center sm:text-base text-medium font-medium whitespace-nowrap h-full'>
                <BasicMenu
                  className='max-w-[200px] whitespace-nowrap   text-ellipsis overflow-hidden'
                  options={options}
                  // title={`${auth?.user?.name} ${auth?.user?.surname || ""}`}
                  title={`${settings?.name || auth.user?.name || mainUser?.name || ""} ${settings?.surname || auth.user?.surname || mainUser?.surname || ""}`}
                  withIcon={<ExpandMore />}
                  chooseOption={onChooseOption}
                />
              </div>
              <div className='sm:hidden flex items-center text-[14px] mr-4 font-semibold text-[#737C86]'></div>
              <div className='flex sm:hidden rounded-2xl bg-white items-center sm:text-base text-medium font-medium whitespace-nowrap h-full'>
                <IconButton onClick={handleMenu}>
                  <Avatar>
                    {auth?.user?.name?.charAt(0) ||
                      settings?.name?.charAt(0) ||
                      mainUser?.name?.charAt(0)}
                  </Avatar>
                </IconButton>
                <MenuMUI
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                >
                  {options.map((option, index) => {
                    if (option.separator) {
                      return (
                        <hr
                          key={`separator-${index}`}
                          style={{
                            margin: "4px 0",
                            border: "none",
                            borderTop: "1px solid #e0e0e0",
                          }}
                        />
                      )
                    }
                    const IconComponent = option.icon
                    return (
                      <MenuItemMUI
                        key={option.title || index}
                        onClick={() => {
                          onChooseOption(option.title)
                          handleClose()
                        }}
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          {IconComponent && (
                            <IconComponent
                              sx={{
                                fontSize: "20px",
                                color: "#737C86",
                              }}
                            />
                          )}
                          <span>{option.title}</span>
                        </div>
                        {option.badge && (
                          <span
                            style={{
                              backgroundColor:
                                option.badge === "Pro"
                                  ? "#14213D"
                                  : "#0E4711FF",
                              color: "white",
                              padding: "2px 8px",
                              borderRadius: "5px",
                              fontSize: "12px",
                              fontWeight: "400",
                              marginLeft: "8px",
                            }}
                          >
                            {option.badge}
                          </span>
                        )}
                      </MenuItemMUI>
                    )
                  })}
                </MenuMUI>
              </div>
            </div>
          </div>
        </div>
        {activePassword && (
          <ChangePass active={activePassword} setActive={setActivePassword} />
        )}
        {activeTel && (
          <ChangePhone active={activeTel} setActive={setActiveTel} />
        )}
      </>
    )
  }
)